import React, { useState, useEffect } from "react";
import { secureApiRequest } from "./Services/secureApiRequest";
import { decryptResponseData } from "./Services/decryptApiResponse";

const baseURL = process.env.REACT_APP_BASE_URL;

// Inline SVG loader
const SvgLoader = ({ width, height, className, style }) => (
  <div className={className} style={style} width={width} height={height}>
    <div className="d-flex justify-content-center align-items-center" style={{ height: "100%", width: "100%" }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: "block" }}
        width="35px"
        height="35px"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
        // className={className}
      >
        <circle
          cx="50"
          cy="50"
          fill="none"
          stroke="var(--theme-default)"
          strokeWidth="8"
          r="35"
          strokeDasharray="164.93361431346415 56.97787143782138"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            repeatCount="indefinite"
            dur="1s"
            values="0 50 50;360 50 50"
            keyTimes="0;1"
          />
        </circle>
      </svg>
    </div>
  </div>
);

const S3ImageLoader = ({
  fileName,
  fallbackSrc,
  width = "",
  height = "",
  className = "",
  id = "",
  alt = "",
  ref = null,
  style = {},
  onClick = () => {},
  onMouseEnter = () => {},
  onMouseLeave = () => {}
}) => {
  const [imageUrl, setImageUrl] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadImage = async () => {
      if (!fileName || fileName === "") {
        setImageUrl(fallbackSrc);
        setLoading(false);
        return;
      }

      if (fileName.startsWith("/uploads/")) {
        setImageUrl(baseURL + fileName);
        setLoading(false);
        return;
      }

      try {
        const response = await secureApiRequest("post", "masters/preSigned-signature", {
          key: fileName,
        });
        const dec_data = decryptResponseData(response);
        setImageUrl(dec_data.data.presignedURL);
      } catch (error) {
        console.error("Error fetching presigned URL:", error);
        setImageUrl(fallbackSrc);
      } finally {
        setLoading(false);
      }
    };

    loadImage();
  }, [fileName, fallbackSrc]);

  const handleImageError = (e) => {
    e.target.src = fallbackSrc;
    setLoading(false);
  };

  if (loading) {
    return <SvgLoader width= "" height="" className={className} id={id} style={style} />;
  }

  return (
    <img
      src={imageUrl || fallbackSrc}
      alt={alt}
      onError={handleImageError}
      onClick={onClick}
      className={className}
      id={id}
      ref={ref}
      loading="lazy"
      style= {style}
      width={width}
      height={height}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  );
};

export default S3ImageLoader;
